import {tns} from 'tiny-slider/src/tiny-slider';

window.tns = tns;

let headerSliderElement = document.getElementById('header-slider')
if(headerSliderElement){
    tns({
        container: headerSliderElement,
        items: 1,
        touch: true,
        slideBy: 'page',
        autoplay: true,
        autoplayButtonOutput: false
    });
}

;(function () {

    let youtubePreviews = document.querySelectorAll('.youtube-preview');

    function click () {

        let th = this;
        let videoId = th.getAttribute('data-video-id');
        let params = th.getBoundingClientRect();
        th.classList.add('loading');


        window.onYouTubeIframeAPIReady = function () {
            new window.YT.Player(th, {
                height: params.height,
                width: params.width,
                videoId,
                events: {
                    onReady: function (event) {
                        th.classList.remove('loading');
                        th.classList.add('active');
                        event.target.playVideo();
                    }
                }
            });
        };

        if(!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')){
            let tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            let firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }else{
            window.onYouTubeIframeAPIReady();
        }


        th.removeEventListener('click', click);
    }

    for (let i = 0; i < youtubePreviews.length; i++) {
        let youtubePreview = youtubePreviews[i];

        youtubePreview.addEventListener('click', click)
    }

})();
